import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { apiRequest } from "../../utils/utils";

const CancelAccount = (props) => {
  const { data } = props;
  const [charge, setCharge] = useState("");
  const [reason, setReason] = useState("");

  const handleIsCharged = (event) => {
    setCharge(event.target.value);
  };

  const handleReason = (event) => {
    setReason(event.target.value);
  };

  const handleSubmit = async () => {
    const postData = {
      product_key: data && data.product,
      app_token: data && data.customer_id,
      studio_id: data && data.customer_id,
      user_id: data && data.customer_user_uuid,
      is_live: data && data.is_live,
      inputs: {
        custom_notes: reason,
        is_charged: charge,
      },
    };

    let crmStagingUrl = process.env.REACT_APP_CRM + "/muvi5/cancel-account";

    const responseData = await apiRequest(crmStagingUrl, "POST", postData);
    console.log(responseData, 45435324234);
  };
  return (
    <Modal show={props.show} onHide={props.close}>
      <Modal.Header closeButton>
        <Modal.Title>{data.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label htmlFor="">Company</label>
          <input
            type="text"
            name=""
            id=""
            className="form-control"
            disabled
            value={data && data.company_name}
          />
        </div>
        <div className="form-group">
          <label htmlFor="">Reason</label>
          <input
            type="text"
            name=""
            id=""
            className="form-control"
            value={reason}
            onChange={handleReason}
          />
        </div>

        <div class="form-group">
          <label for="recipient-name" className="control-label">
            Do you want to charge this customer?
          </label>
          <div class="radio feature-check">
            <input
              class="valid_fld"
              id="3"
              type="radio"
              name="is_charged"
              value="1"
              onChange={handleIsCharged}
            />
            <label for="3">
              <span></span>Yes
            </label>
          </div>
          <div class="radio feature-check">
            <input
              class="valid_fld"
              id="4"
              type="radio"
              name="is_charged"
              value="0"
              onChange={handleIsCharged}
            />
            <label for="4">
              <span></span>No
            </label>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.close}>Close</Button>
        <Button onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelAccount;



// WEBPACK FOOTER //
// ./src/components/childcomponents/CancelAccount.js